import { AreaUnit } from '@search/filter-enums/enums/AreaUnit';
import { Currency } from '@search/filter-enums/enums/Currency';
import { formatNumber } from '@search/helpers/src/formatNumber';
import { currencyMapping } from '@search/filter-enums/mappings/currency_mapping';
import { areaUnitMapping } from '@search/filter-enums/mappings/area_unit_mapping';

export interface IGenDetailPrice {
    priceValue: number;
    priceCurrency?: Currency;
    totalAreaUnit?: AreaUnit;
    totalAreaValue: number | string;
    short?: boolean;
}

export const generateDetailPrice = (p: IGenDetailPrice) => {
    const {
        priceValue,
        priceCurrency = Currency.RUB,
        totalAreaValue,
        totalAreaUnit = AreaUnit.METER,
        short = false
    } = p;

    if (! priceValue || ! priceCurrency || ! totalAreaValue) {
        return null;
    }

    let value = totalAreaValue;

    if (typeof value === 'string') {
        value = parseFloat(value);
    }

    // Fix for correct round 0.128388484848 numbers
    value = Math.round(value * 1e2) / 1e2;

    if (value === 0) {
        return null;
    }

    const priceText = [ formatNumber(Math.round(priceValue / value)), currencyMapping[priceCurrency] ];

    const text = priceText.join('\u00A0') + (! short ? '\u00A0за\u00A0' : '/') + areaUnitMapping[totalAreaUnit];

    return text;
};
